import { useCallback, useMemo } from 'react';

import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';
import { useCurrentUserId } from '#src/app/shared/hooks/session';
import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';
import { useIsMobile } from '#src/app/shared/hooks/userAgent';

export function useGetShareTrackingData(): ShareActionsOptions['getTrackingData'] {
	const userId = useCurrentUserId();
	const sourceLocation = useQueryParamValue('source_location');
	const isMobile = useIsMobile();
	const {
		data: {
			initial,
			petition: { id, user, photo, bestShareVisual },
		},
	} = usePsfSharePageData();

	const commonTrackingData = useMemo(
		() => ({
			context: initial ? 'psf_combo_share_initial' : 'psf_combo_share_message',
			view_context: initial ? 'psf_combo_share_initial' : 'psf_combo_share_message',
			source_location: sourceLocation,
			petition_id: `petition_${id}`,
			own_petition: userId === user.id,
			showImage: !!photo,
			is_share_asset: isMobile && !!bestShareVisual?.url,
		}),
		[sourceLocation, id, userId, user.id, initial, isMobile, photo, bestShareVisual?.url],
	);

	return useCallback(
		(_channel: ShareChannel) => {
			switch (_channel) {
				default:
					return commonTrackingData;
			}
		},
		[commonTrackingData],
	);
}
